/**
 * Normalize a campaign's eligible games into the shape the widget renders:
 * the special `"ALL"` sentinel, or a list of game names (with the total count,
 * since the list may be a preview subset). Shared by every campaign type so the
 * `"ALL"` / empty / list branching lives in exactly one place. `allGamesCount`
 * is the wire's `eligible_games_count`: how many games an `"ALL"` selection
 * covers (the list itself never ships), so `"ALL"` can carry a count too.
 */
export function toGameNames(
  eligible: { name: string }[] | "ALL" | null | undefined,
  allGamesCount?: number | null
): { games: string[] | "ALL"; count?: number } {
  if (eligible === "ALL")
    return { games: "ALL", count: allGamesCount ?? undefined };
  if (!eligible) return { games: [] };
  // One Game row per device variant — a mobile and a desktop "Book of Dead"
  // share a name and differ only by custom_id — and the widget shows names
  // only, so the variants read as duplicated games (and double the count in
  // "Eligible games · N"). De-duplicate by name, first-seen order. The
  // per-prize lists already arrive distinct (the backend resolves those through
  // a set in `prize_game_names`), so this is what makes the two lists agree.
  const names = [...new Set(eligible.map((g) => g.name))];
  return { games: names, count: names.length };
}
